export const EmailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;// eslint-disable-line
export const phoneRegex = /^[0-9]*$/;
export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
export const VatIdRegex = /^[A-Z]{2}[0-9A-Z]{2,}$/;
export const latitudeRegex = /^(-?[1-8]?[0-9](\.\d+)?|90(\.0+)?)$/;
export const longitudeRegex = /^(-?(1[0-7][0-9]|[1-9]?[0-9])(\.\d+)?|180(\.0+)?)$/;
export const Swiftcode = /^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$/;
export const IBANcode = /^[A-Z]{2}[0-9]{2}[A-Z0-9]{1,30}$/;

